import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { FeatureMap, featureLabel } from "../../services/superadminService";

interface FeatureChipsProps {
  features: FeatureMap;
  /** Canonical order from `GET /superadmin/features`. */
  keys?: string[];
}

/** Three small chips, lit or dim. */
const FeatureChips: React.FC<FeatureChipsProps> = ({ features, keys }) => {
  const order = keys && keys.length ? keys : Object.keys(features || {});

  return (
    <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
      {order.map((key) => {
        const enabled = !!features?.[key];
        return (
          <Tooltip
            key={key}
            title={`${featureLabel(key)} ${enabled ? "enabled" : "disabled"}`}
          >
            <Chip
              size="small"
              label={featureLabel(key)}
              variant={enabled ? "filled" : "outlined"}
              sx={{
                fontSize: "0.72rem",
                height: 22,
                fontWeight: 600,
                ...(enabled
                  ? { bgcolor: "#e3f0e8", color: "#2c6e4b", border: "none" }
                  : { color: "#9aa3a0", borderColor: "#dfe3e1" }),
              }}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default FeatureChips;
